import { Tabs as AntTabs, TabsProps } from 'antd';

const Tabs = ({ ...props }: TabsProps) => {
  return <AntTabs {...props} type='line' className={`${props.className}`}></AntTabs>;
};

export default Tabs;
